module.exports = __webpack_public_path__ + "img/synchro.786d0110.svg";